module.exports = __webpack_public_path__ + "static/media/autobookList.92b1781d.svg";